import { Component, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import packageInfo from '../../../../package.json';
import { LoaderComponent } from '@app-components/common/loader/loader.component';
import { CacheBusterService } from '@app-services/сache-buster.service';
import { FeClient } from '@app-services/api/clients/fe.client';
import { AuthenticationService } from '@app-services/auth/authentication.service';

@Component({
  selector: 'app-error-page',
  imports: [MatButtonModule, TranslateModule, RouterLink, LoaderComponent],
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
})
export class ErrorPageComponent implements OnInit {
  error: {
    [key: string]: {
      title: string;
      subTitle: string;
      src: string;
    };
  } = {
    '403': {
      title: 'noPermission',
      subTitle: 'youDontHavePermission',
      src: '../../../assets/403.svg',
    },
    '401': {
      title: 'unauthorized',
      subTitle: 'notLoggedIn',
      src: '../../../assets/401.svg',
    },
    '500': {
      title: 'internalServerError',
      subTitle: '',
      src: '../../../assets/500.svg',
    },
    '404': {
      title: 'noSuchPageExists',
      subTitle: '',
      src: '../../../assets/404.svg',
    },
    requesterror: {
      title: 'pageCannotBeShown',
      subTitle: '',
      src: '../../../assets/500.svg',
    },
    versionError: {
      title: 'newVersion',
      subTitle: '',
      src: '../../../assets/something-went-wrong.svg',
    },
  };
  errorCode = '';
  public returnUrl: string;
  public canRedirectToHomePage: boolean;
  public homeUrl: string | null;
  isLoading = false;

  constructor(
    private router: Router,
    private feClient: FeClient,
    private cacheBusterService: CacheBusterService,
    private authenticationService: AuthenticationService
  ) {}

  async ngOnInit(): Promise<void> {
    const urlArr: string[] = window.location.pathname.split('/');
    const errorCode = this.error?.[urlArr[urlArr.length - 1]]?.title
      ? urlArr[urlArr.length - 1]
      : '404';

    if (errorCode === '500') {
      const versionError = await this.checkVersion();
      if (versionError) {
        this.errorCode = 'versionError';
        return;
      }
    }
    this.errorCode = errorCode;

    this.homeUrl = `/`;
    this.canRedirectToHomePage = true;
    this.returnUrl = this.router.currentNavigation()?.extras?.state?.returnUrl;
  }

  async checkVersion(): Promise<boolean> {
    try {
      this.isLoading = true;
      const res = await this.feClient.getVersion();
      return res.version !== packageInfo.version;
    } catch (e) {
      return false;
    } finally {
      this.isLoading = false;
    }
  }

  update(): void {
    this.cacheBusterService.forceReload();
  }

  changeUser(): void {
    this.authenticationService.logout(true);
  }
}
